<script>
  import { navigate } from "svelte-routing";
  import Menu from "./Menu.svelte";
	import { Burger } from '@svelteuidev/core';
    import { versaoTeste } from "../Classes/Stores";

  export let pagAnterior = "";

  let opened = false;
  let menuOpen = false;

  function acaoBotao() {
    menuOpen = !menuOpen;
    opened = !opened;
  }

  function Retornar() {
    navigate(pagAnterior);
  }


</script>

<nav class="navbar navbar-expand-lg navbar-orange fixed-top">
  <div class="container">
    {#if pagAnterior != ""}
      <span on:click={Retornar} class="navbar-brand branca">
        <i class="fas fa-arrow-left"></i>
      </span>
    {/if}
    <a class="navbar-brand" href="#">
      <img src="img/WODOXI_timbre.png" alt="Logo" height="40" />
    </a>
{#if $versaoTeste==1}
<h6>V. TESTE</h6>

{/if}
   
    
<Menu {menuOpen} />
  </div>
</nav>



<style>
  .navbar-orange {
    background-color: #cbd4fd; /* Laranja #d2520b */
    border-bottom: 2px solid #3659fc; /* Adiciona uma borda superior */
  }

  .fixed-top {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1030; /* z-index maior que o conteúdo */
  }

  .abaixo {
    top: 0;
    left: 0;
    right: 0;
    margin-bottom: 2em;
    /* z-index maior que o conteúdo */
  }

  .content-below-nav {
    margin-top: 5em; /* Ajuste a altura do nav conforme necessário */
    /* 56px é a altura padrão da navbar do Bootstrap */
    /* Isso garante que o conteúdo não seja sobreposto pelo nav fixo */
  }
  .branca {
    color: white;
  }
  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  /* Adicionando animação ao ícone */
  .rotate-effect {
    animation: rotate 0.3s linear;
  }
</style>